import React from 'react';
import { _defineHelpUrlandToolTip } from '../helpers/index.js'

const CountWith = function () {
    const name = "count_with";
    CountWith.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#loops");

    return (
        <block type={name}>
            <value name="FROM">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="TO">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
            <value name="BY">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
    );
};

export default CountWith;